module.exports = __webpack_public_path__ + "40e2e9753eec721d9bc586ed9ae3c712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tcd-mn.png
// module id = 2014
// module chunks = 0